<template>
	<div class="container">
		<div class="news-detail">
			<div class="nd-body">
				<div class="bread-nav">
					<span @click="navgoTo()">全部</span> > 播聘新闻 > <span class="txt-gray">{{objData.title}}</span>
				</div>
				<div class="nd-body-content">
					<div class="nd-body-view">
						<div class="nd-body-view-title">{{objData.title}}</div>
						<div class="nd-body-view-from">来源:{{objData.froms}} | {{objData.date}} | 播聘新闻</div>
						<div class="nd-body-view-content">{{objData.content}}</div>
						<div class="nd-body-view-content">
							<img src="../../../static/live.jpg" alt="map"/>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitle}}</h3>
							<div>{{objData.contenta}}<br/></div>
							<div  style="padding-top:20px;">{{objData.contenta1}}<br/></div>
							<div  style="padding-top:20px;">{{objData.contenta2}}<br/></div>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitleb}}</h3>
							<div>{{objData.contentb1}}<br/></div>
							<div>{{objData.contentb2}}<br/></div>
							<div>{{objData.contentb3}}</div>
							<div>{{objData.contentb4}}</div>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitlec}}</h3>
							<div>{{objData.contentc1}}</div>
							<div>{{objData.contentc2}}</div>
							<!-- <div>{{objData.contentb3}}</div>
							<div>{{objData.contentb4}}</div> -->
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitled}}</h3>
							<div>{{objData.contentd1}}</div>
							<div>{{objData.contentd2}}</div>
							<!-- <div>{{objData.contentb3}}</div>
							<div>{{objData.contentb4}}</div> -->
						</div>
						<div class="nd-body-view-of">
							<div class="nd-body-view-prev">上一篇：{{objData.prev}}</div>
							<div>下一篇：{{objData.next}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'showLive',
		data(){
			return {
				id:'',
				objData:{
					title:`【播聘观察】企业直播招聘 是因时而变`,
					date:`2019年9月12日`,
					froms:`播聘`,
					next:`播聘荣登准独角兽百强榜，以技术驱动深耕服务业招聘`,
					prev: `播聘“千人千面”智能推荐策略的产品分析，我的工作我做主 `,
					content:`随着“75后”占据高管席，“85后”成为中流砥柱，“95后”也逐渐进入职场成为新动能。越来越多的“95后”选择“慢就业”，甚至对按部就班上班失去兴趣。这类心态的出现，给做招聘的HR巨大的压力，HR们开始将招聘主场搬至年轻人群聚集最多的地方，例如直播平台。与此同时，不少企业也玩起了直播招聘。（2月25日 《劳动报》）`,
					contenta:`伴随着网络融入各行各业，对企业招聘而言，已经不再仅局限于招聘会，或者发布招聘广告这些传统模式，而微信等社交平台招聘已经渗入到招聘领域。伴随着网络直播的红火，一些企业试水通过直播招聘，无疑更是因时而变之举，为企业招到合适的人开辟了新渠道。`,
					contenta1:`企业试水直播招聘具有多重积极意义。一则更能够彰显企业招揽人才的诚意；二则也有助于提升企业的知名度；三则从求职者角度来看，也能够减少一定的求职就业成本。从实践来看，一些企业借助直播招聘取得了不错的效果，而一些品牌企业也参与其中。而其重要的意义，更在于可以增进企业与求职者的互动，是对双方都有利的事情。`,
					contenta2:`当然，企业直播招聘作为一种创新，所应遵循的边界也不能缺失。一则在直播中应坚持实事求是，最基本的直播企业状况当是自家的，尤其是承诺的相关待遇、岗位等事项也应出于真心、诚心；二则应该加强对求职者个人信息的保护，以防范求职者简历等个人信息遭到泄露；三则在直播操作上，同样须遵守法律规定及社会公序良俗，谨防越界言行的出现。`,

					subtitleb:`求职招聘，就用播聘`,
					contentb1:`　同时，于求职者而言，面对企业直播招聘形式，应好好利用这样的平台，此外，必要的防范意识也不能缺失，比如，对于看好的企业，不能仅停留在直播时的头脑一热，对线下企业口碑的了解也很重要。`,
					contentb2:`总之，企业试水直播招聘是因时而变的有益举措。正如媒体报道，传统网络招聘的市场份额已经在萎缩，直播这类移动社交招聘一定会慢慢成为主流。对此，无论是企业还是求职者，不妨就好好利用。`,
				}
			}
		},
		created(option) {
			this.init()
		},
		methods:{
			init(){
				let _this = this;
				_this.id = _this.$route.query.id || ``;
				
			},
			navgoTo(){
				this.$nav({path:`/show-news`},this)
			}
		}
	}
</script>

<style scoped="scoped">

	@import url("./show-live.css");
</style>



// WEBPACK FOOTER //
// src/pages/show-live/show-live.vue